import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faEyeSlash, faUser, faShieldAlt, faCarSide, faSignOutAlt, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import ResetPasswordModal from './components/ResetPassword/ResetPasswordModal';
import HideVehicleHistoryModal from './components/HideVehicle/HideVehicleHistoryModal';
import { profileRepository } from '../../../../../repositories/profileRepository';
import { logout as endSession } from '../../../../../services/sessionService';
import AlertModal from '../../../../../components/alertModal/AlertModal';
import { cpfOrCnpjMask, phoneMask } from '../../../../../utils/normalize';
import './Profile.css';

const FIELDS = [
  { key: 'name', label: 'Nome completo' },
  { key: 'cpfCnpj', label: 'CPF/CNPJ', format: (v) => cpfOrCnpjMask(v || '') },
  { key: 'phone', label: 'Celular', format: (v) => phoneMask(v || '') },
  { key: 'email', label: 'E-mail' },
];

class Profile extends Component {
  state = {
    showResetModal: false,
    showHideHistoryModal: false,
    confirmLogout: false,
    loading: true,
    failed: false,
    name: '',
    cpfCnpj: '',
    phone: '',
    email: '',
  };

  componentDidMount() {
    this.fetchUserData();
  }

  fetchUserData = async () => {
    try {
      const response = await profileRepository.getProfile();
      this.setState({
        loading: false,
        name: response.data.name,
        cpfCnpj: response.data.cpfCnpj,
        phone: response.data.phone,
        email: response.data.email,
      });
    } catch (error) {
      // Sem os dados a pagina avisa em vez de mostrar campos vazios.
      this.setState({ loading: false, failed: true });
    }
  };

  logout = async () => {
    await endSession('client');
    window.location.href = '/client/login';
  };

  render() {
    const { loading, failed } = this.state;

    return (
      <div className="gs-stack">
        <header className="gs-page-header">
          <span className="gs-eyebrow">Perfil</span>
          <h1>Seus dados</h1>
          <p>Os dados da sua conta no Sobre Rodas.</p>
        </header>

        {failed && <p className="gs-notice gs-notice-error" role="alert">Não foi possível carregar os seus dados agora. Atualize a página para tentar de novo.</p>}

        <section className="pf-card" aria-labelledby="pf-data-title">
          <h2 id="pf-data-title" className="pf-card-title">
            <span className="gs-icon gs-icon-orange" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></span>
            Conta
          </h2>
          <dl className="pf-fields" aria-busy={loading ? 'true' : undefined}>
            {FIELDS.map((field) => {
              const value = this.state[field.key];
              return (
                <div key={field.key} className="pf-field">
                  <dt>{field.label}</dt>
                  <dd>{loading ? <span className="pf-placeholder" /> : (field.format ? field.format(value) : value) || '—'}</dd>
                </div>
              );
            })}
          </dl>
        </section>

        <section className="pf-card" aria-labelledby="pf-security-title">
          <h2 id="pf-security-title" className="pf-card-title">
            <span className="gs-icon gs-icon-teal" aria-hidden="true"><FontAwesomeIcon icon={faShieldAlt} /></span>
            Segurança
          </h2>
          <p className="pf-text">Ao trocar a senha, as sessões abertas em outros aparelhos são encerradas.</p>
          <button type="button" className="gs-btn gs-btn-primary pf-action" onClick={() => this.setState({ showResetModal: true })}>
            <FontAwesomeIcon icon={faKey} aria-hidden="true" />
            Alterar senha
          </button>
        </section>

        <section className="pf-card" aria-labelledby="pf-vehicles-title">
          <h2 id="pf-vehicles-title" className="pf-card-title">
            <span className="gs-icon gs-icon-violet" aria-hidden="true"><FontAwesomeIcon icon={faCarSide} /></span>
            Veículos
          </h2>
          <Link to="/client/vehicles" className="pf-link-row">
            <span>Gerenciar veículos da garagem</span>
            <FontAwesomeIcon icon={faChevronRight} aria-hidden="true" />
          </Link>
        </section>

        <button type="button" className="gs-btn gs-btn-secondary pf-logout" onClick={() => this.setState({ confirmLogout: true })}>
          <FontAwesomeIcon icon={faSignOutAlt} aria-hidden="true" />
          Sair da conta
        </button>

        <section className="pf-card pf-card-danger" aria-labelledby="pf-privacy-title">
          <h2 id="pf-privacy-title" className="pf-card-title">Privacidade</h2>
          <p className="pf-text">
            Você pode ocultar o histórico dos seus veículos. Com isso, o acesso ao histórico no Sobre Rodas é
            encerrado e você sai da conta.
          </p>
          <button type="button" className="gs-btn pf-danger-btn pf-action" onClick={() => this.setState({ showHideHistoryModal: true })}>
            <FontAwesomeIcon icon={faEyeSlash} aria-hidden="true" />
            Ocultar meu histórico
          </button>
        </section>

        <AlertModal
          show={this.state.confirmLogout}
          animation={false}
          message="Deseja realmente sair?"
          onHide={() => this.setState({ confirmLogout: false })}
          onCancel={() => this.setState({ confirmLogout: false })}
          onSubmit={this.logout}
        />
        <ResetPasswordModal
          show={this.state.showResetModal}
          onHide={() => this.setState({ showResetModal: false })}
        />
        <HideVehicleHistoryModal
          show={this.state.showHideHistoryModal}
          onHide={() => this.setState({ showHideHistoryModal: false })}
          history={this.props.history}
        />
      </div>
    );
  }
}

export default Profile;
